"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CardHeader = void 0;
require("./CardHeader.css");
var _classnames = _interopRequireDefault(require("classnames"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _renderObject = require("../../util/renderObject/renderObject");
var _Image = _interopRequireDefault(require("../Image/Image"));
var _Tag = _interopRequireDefault(require("../Tag/Tag"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * CardHeader component
 * @method
 * @param {object} props - React properties passed from composition
 * @returns CardHeader
 */

const CardHeader = props => {
  const {
    tagsTop,
    externalMedia,
    headerPadding,
    image
  } = props;
  const componentClassName = (0, _classnames.default)('pal-c-CardHeader', {
    [`pal-c-CardHeader__padding--${headerPadding}`]: headerPadding
  });
  const hasTagsArray = tagsTop?.length > 0;
  const displayContent = () => {
    switch (true) {
      case !!externalMedia:
        return (0, _renderObject.renderObject)(externalMedia);
      case !!image:
        return /*#__PURE__*/_react.default.createElement(_Image.default, {
          desktopImage: image?.desktopImage,
          tabletImage: image?.tabletImage,
          mobileImage: image?.mobileImage,
          altText: image?.altText,
          ratio: image?.ratio,
          loading: image?.loading
        });
      default:
        return null;
    }
  };
  const renderTags = () => {
    if (!hasTagsArray) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "pal-c-CardHeader__tagsTop"
    }, tagsTop.map((tagProps, index) => /*#__PURE__*/_react.default.createElement(_Tag.default, _extends({
      key: `tag-${index} `
    }, tagProps))));
  };
  return /*#__PURE__*/_react.default.createElement("div", {
    className: componentClassName
  }, renderTags(), /*#__PURE__*/_react.default.createElement("div", {
    className: "pal-c-CardHeader__imageContainer"
  }, displayContent()));
};

/**
 * Property type definitions
 * @type {object}
 * @property {object} externalMedia - url, altText, ratio and loading prop for external image or video
 * @property {object} image - url, altText, ratio and loading prop for Image component
 * @property {array} tagsTop - Allows passing an array of tag objects to display in the card header
 */
exports.CardHeader = CardHeader;
CardHeader.propTypes = {
  /**
   * Allows header prop to accept an object of external media
   */
  externalMedia: _propTypes.default.object,
  /**
   * Allows header prop to accept an object
   * - **imgAlt:** The alt text for the image
   * - **imgSrc:** The URL for the image
   * - **imgRatio:** The ratio for the image oneOf( ['1x1', '4x5', '5x4', '9x16', '16x9'] ),
   */
  image: _propTypes.default.object,
  /**
   * Allows passing an array of tag objects to the ProductCardHeader
   * See tag component for more detail ../Tag/Tag.jsx
   */
  tagsTop: _propTypes.default.arrayOf(_propTypes.default.object)
};
var _default = exports.default = CardHeader;